var _line, _rect, _g, _path, _path2, _rect2, _path3, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSlide3 = function SvgSlide3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 60,
    viewBox: "0 0 214 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 27,
    x2: 152,
    y2: 27,
    stroke: "#243038",
    strokeWidth: 2,
    strokeDasharray: "8 8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#243038"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12555_40716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9195 12.1763H27.086C18.8563 12.1763 12.1875 19.2624 12.1875 28.0001C12.1875 36.7378 18.8563 43.8239 27.086 43.8239H28.9195C37.1493 43.8239 43.818 36.7378 43.818 28.0001C43.818 19.2624 37.1493 12.1763 28.9195 12.1763Z",
    fill: "#8F929E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9167 44H27.0833C18.7658 44 12 36.8214 12 28C12 19.1786 18.7658 12 27.0833 12H28.9167C37.2342 12 44 19.1786 44 28C44 36.8214 37.2342 44 28.9167 44ZM27.0833 12.3523C18.969 12.3523 12.3695 19.3724 12.3695 28C12.3695 36.6276 18.969 43.6477 27.0833 43.6477H28.9167C37.031 43.6477 43.6305 36.6276 43.6305 28C43.6305 19.3724 37.031 12.3523 28.9167 12.3523H27.0833Z",
    fill: "#727481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8787 38.7152C42.3217 35.8966 43.818 32.1355 43.818 28.0001C43.818 27.8811 43.8134 27.7622 43.8088 27.6389H12.1967C12.1967 27.7578 12.1875 27.8767 12.1875 28.0001C12.1875 32.1355 13.6838 35.8966 16.1269 38.7152H39.8787Z",
    fill: "url(#paint0_linear_12555_40716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.086 43.8239C35.3143 43.8239 41.9846 36.7394 41.9846 28.0001C41.9846 19.2608 35.3143 12.1763 27.086 12.1763C18.8578 12.1763 12.1875 19.2608 12.1875 28.0001C12.1875 36.7394 18.8578 43.8239 27.086 43.8239Z",
    fill: "#C3C5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0833 44C18.7658 44 12 36.8214 12 28C12 19.1786 18.7658 12 27.0833 12C35.4008 12 42.1665 19.1786 42.1665 28C42.1665 36.8214 35.4008 44 27.0833 44ZM27.0833 12.3523C18.969 12.3523 12.3695 19.3724 12.3695 28C12.3695 36.6276 18.969 43.6477 27.0833 43.6477C35.1976 43.6477 41.7971 36.6276 41.7971 28C41.7971 19.3724 35.1976 12.3523 27.0833 12.3523Z",
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7975 25.2476C25.8345 25.2388 25.8668 25.2299 25.9038 25.2211C26.1439 25.1551 26.3887 25.089 26.6242 25.023C31.3626 23.7326 36.2117 22.9662 41.0933 22.6095C39.0197 16.5231 33.5331 12.1763 27.086 12.1763C18.8563 12.1763 12.1875 19.2624 12.1875 28.0001C12.1875 28.7752 12.2429 29.5371 12.3445 30.2814C16.4363 27.8768 21.3363 26.4675 25.7975 25.2476Z",
    fill: "url(#paint1_linear_12555_40716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0857 40.97C33.8295 40.97 39.2964 35.1632 39.2964 28C39.2964 20.8369 33.8295 15.03 27.0857 15.03C20.3419 15.03 14.875 20.8369 14.875 28C14.875 35.1632 20.3419 40.97 27.0857 40.97Z",
    fill: "url(#paint2_linear_12555_40716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4218 40.3006C33.8161 40.3006 38.9998 34.7935 38.9998 28C38.9998 21.2066 33.8161 15.6995 27.4218 15.6995C21.0274 15.6995 15.8438 21.2066 15.8438 28C15.8438 34.7935 21.0274 40.3006 27.4218 40.3006Z",
    fill: "#C3C5D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4482 27.9031C23.6255 26.9739 26.8445 26.1107 30.105 25.4853C32.7836 24.97 35.6377 24.512 38.4918 24.3843C37.037 19.3592 32.6312 15.7039 27.4218 15.7039C21.0255 15.7039 15.8438 21.2089 15.8438 28.0044C15.8438 28.4889 15.8715 28.9689 15.9269 29.4402C17.414 28.8852 18.9149 28.3612 20.4528 27.9075L20.4482 27.9031Z",
    fill: "url(#paint3_linear_12555_40716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5278 40.0451C28.9829 40.0451 28.4148 40.0363 27.8699 40.0055C27.3711 39.9791 26.8769 39.7633 26.4613 40.12C26.2442 40.3094 26.175 40.5736 26.3458 40.8203C26.7245 41.362 27.4542 41.2078 28.0454 41.1285C28.6965 41.0405 29.1815 40.8335 29.7126 40.4811C29.9389 40.327 29.7726 40.0451 29.5325 40.0451H29.5278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2206 12.48C24.0174 12.3787 23.7958 12.2994 23.5648 12.3479C23.3247 12.4007 23.1353 12.5725 23.1677 12.8235C23.1954 13.0613 23.4217 13.2243 23.6664 13.2022C23.9389 13.1802 24.1329 13.0349 24.313 12.8543C24.4377 12.731 24.3546 12.5416 24.2206 12.4712V12.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12555_40716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0876 19.5486L25.0257 35.8437H21.0078L24.0466 19.5486H28.0876ZM32.1609 26.1547L31.579 29.2375H25.095L25.6769 26.1547H32.1609ZM33.9159 19.5486L33.3386 22.6314H26.365L26.9561 19.5486H33.9205H33.9159Z",
    fill: "#8F929E"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 56C48.4183 56 52 52.4183 52 48C52 43.5817 48.4183 40 44 40C39.5817 40 36 43.5817 36 48C36 52.4183 39.5817 56 44 56Z",
    fill: "#6DAD52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.954 52L40 49.2027L41.3462 47.9279L42.954 49.455L47.6538 45L49 46.2748L42.954 52Z",
    fill: "#131A1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#243038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.743 34.169C209.932 37.4182 208.49 40.4761 206.498 43.168C204.506 45.8599 202.004 48.1331 199.133 49.8578C196.263 51.5825 193.081 52.7249 189.769 53.2199C186.457 53.7149 183.08 53.5527 179.831 52.7425C176.582 51.9324 173.524 50.4902 170.832 48.4983C168.14 46.5065 165.867 44.0039 164.142 41.1335C162.418 38.2631 161.275 35.0811 160.78 31.7691C160.285 28.4572 160.447 25.0802 161.257 21.831C162.068 18.5818 163.51 15.5239 165.502 12.832C167.494 10.1401 169.996 7.86694 172.867 6.14223C175.737 4.41752 178.919 3.27506 182.231 2.78009C185.543 2.28512 188.92 2.44733 192.169 3.25746C195.418 4.06759 198.476 5.50976 201.168 7.50165C203.86 9.49354 206.133 11.9961 207.858 14.8665C209.582 17.7369 210.725 20.9189 211.22 24.2309C211.715 27.5428 211.553 30.9198 210.743 34.169L210.743 34.169Z",
    stroke: "#131A1D",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12555_40716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.919 12.1763H185.086C176.856 12.1763 170.188 19.2624 170.188 28.0001C170.188 36.7378 176.856 43.8239 185.086 43.8239H186.919C195.149 43.8239 201.818 36.7378 201.818 28.0001C201.818 19.2624 195.149 12.1763 186.919 12.1763Z",
    fill: "#CD7D0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.917 44H185.083C176.766 44 170 36.8214 170 28C170 19.1786 176.766 12 185.083 12H186.917C195.234 12 202 19.1786 202 28C202 36.8214 195.234 44 186.917 44ZM185.083 12.3523C176.969 12.3523 170.369 19.3724 170.369 28C170.369 36.6276 176.969 43.6477 185.083 43.6477H186.917C195.031 43.6477 201.631 36.6276 201.631 28C201.631 19.3724 195.031 12.3523 186.917 12.3523H185.083Z",
    fill: "#AB6004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.879 38.7152C200.322 35.8966 201.818 32.1355 201.818 28.0001C201.818 27.8811 201.813 27.7622 201.809 27.6389H170.197C170.197 27.7578 170.188 27.8767 170.188 28.0001C170.188 32.1355 171.684 35.8966 174.127 38.7152H197.879Z",
    fill: "url(#paint4_linear_12555_40716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.086 43.8239C193.314 43.8239 199.985 36.7394 199.985 28.0001C199.985 19.2608 193.314 12.1763 185.086 12.1763C176.858 12.1763 170.188 19.2608 170.188 28.0001C170.188 36.7394 176.858 43.8239 185.086 43.8239Z",
    fill: "#F2B829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.083 44C176.766 44 170 36.8214 170 28C170 19.1786 176.766 12 185.083 12C193.401 12 200.167 19.1786 200.167 28C200.167 36.8214 193.401 44 185.083 44ZM185.083 12.3523C176.969 12.3523 170.369 19.3724 170.369 28C170.369 36.6276 176.969 43.6477 185.083 43.6477C193.198 43.6477 199.797 36.6276 199.797 28C199.797 19.3724 193.198 12.3523 185.083 12.3523Z",
    fill: "#FFED8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.798 25.2476C183.834 25.2388 183.867 25.2299 183.904 25.2211C184.144 25.1551 184.389 25.089 184.624 25.023C189.363 23.7326 194.212 22.9662 199.093 22.6095C197.02 16.5231 191.533 12.1763 185.086 12.1763C176.856 12.1763 170.188 19.2624 170.188 28.0001C170.188 28.7752 170.243 29.5371 170.345 30.2814C174.436 27.8768 179.336 26.4675 183.798 25.2476Z",
    fill: "url(#paint5_linear_12555_40716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.086 40.97C191.829 40.97 197.296 35.1632 197.296 28C197.296 20.8369 191.829 15.03 185.086 15.03C178.342 15.03 172.875 20.8369 172.875 28C172.875 35.1632 178.342 40.97 185.086 40.97Z",
    fill: "url(#paint6_linear_12555_40716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.422 40.3006C191.816 40.3006 197 34.7935 197 28C197 21.2066 191.816 15.6995 185.422 15.6995C179.027 15.6995 173.844 21.2066 173.844 28C173.844 34.7935 179.027 40.3006 185.422 40.3006Z",
    fill: "#F2B829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.448 27.9031C181.626 26.9739 184.844 26.1107 188.105 25.4853C190.784 24.97 193.638 24.512 196.492 24.3843C195.037 19.3592 190.631 15.7039 185.422 15.7039C179.025 15.7039 173.844 21.2089 173.844 28.0044C173.844 28.4889 173.871 28.9689 173.927 29.4402C175.414 28.8852 176.915 28.3612 178.453 27.9075L178.448 27.9031Z",
    fill: "url(#paint7_linear_12555_40716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.528 39.9526C186.983 39.9526 186.415 39.9438 185.87 39.913C185.371 39.8865 184.877 39.6707 184.461 40.0275C184.244 40.2169 184.175 40.4811 184.346 40.7277C184.725 41.2694 185.454 41.1153 186.045 41.036C186.697 40.9479 187.181 40.7409 187.713 40.3886C187.939 40.2345 187.773 39.9526 187.532 39.9526H187.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.221 12.3874C182.017 12.2862 181.796 12.2069 181.565 12.2553C181.325 12.3082 181.135 12.4799 181.168 12.731C181.195 12.9688 181.422 13.1317 181.666 13.1097C181.939 13.0877 182.133 12.9424 182.313 12.7618C182.438 12.6385 182.355 12.4491 182.221 12.3786V12.3874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12555_40716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.088 19.4912L183.026 35.7863H179.008L182.047 19.4912H186.088ZM190.161 26.0973L189.579 29.1802H183.095L183.677 26.0973H190.161ZM191.916 19.4912L191.339 22.5741H184.365L184.956 19.4912H191.92H191.916Z",
    fill: "url(#paint8_linear_12555_40716)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12555_40716",
    x: 21.0078,
    y: 19.5486,
    width: 13.9141,
    height: 17.2952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647059 0 0 0 0 0.647059 0 0 0 0 0.647059 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12555_40716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12555_40716",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12555_40716",
    x: 179.008,
    y: 19.4912,
    width: 13.9141,
    height: 17.2952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647059 0 0 0 0 0.360784 0 0 0 0 0.0470588 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12555_40716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12555_40716",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12555_40716",
    x1: 29.3628,
    y1: 39.0543,
    x2: 27.8994,
    y2: 26.4507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6E707D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E707D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12555_40716",
    x1: 22.7587,
    y1: 17.1088,
    x2: 31.251,
    y2: 38.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E0E3F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12555_40716",
    x1: 26.5177,
    y1: 24.9832,
    x2: 28.6024,
    y2: 37.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E919D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A2A5B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A9ACB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C7C9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E4F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12555_40716",
    x1: 22.1338,
    y1: 16.3513,
    x2: 32.4828,
    y2: 39.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EDF0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#E0E3F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12555_40716",
    x1: 187.363,
    y1: 39.0543,
    x2: 185.899,
    y2: 26.4507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B15700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B15700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12555_40716",
    x1: 180.759,
    y1: 17.1088,
    x2: 189.251,
    y2: 38.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFCF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFCF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12555_40716",
    x1: 184.518,
    y1: 24.9832,
    x2: 186.602,
    y2: 37.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB7B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DD930C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E69A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F3BC32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12555_40716",
    x1: 180.134,
    y1: 16.3513,
    x2: 190.483,
    y2: 39.5288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFCF51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFCF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12555_40716",
    x1: 179.008,
    y1: 27.6387,
    x2: 194.119,
    y2: 27.6387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D47B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E69A0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFA411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FCC433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF9B18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12555_40716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12555_40716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(170 12)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlide3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slide3.3edfaac2.svg";
export { ForwardRef as ReactComponent };